import { createVNode as o, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/LogManageFilledStandard.js";
import l from "../components/PfIcon.js";
const a = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return o(l, n(t, {
    icon: d
  }), null);
};
a.displayName = "LogManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
